<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>採用順算出: {{ _adoptOrder }}</div>
    <div>採用順調整: {{ _orderAdjustment }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'
import { LEAF_TYPE_LABELS, ADOPT_ORDER_LABELS } from '@/const/shin-tapir'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    adoptOrder: String,
    orderAdjustment: Object,
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    leafType() {
      return LEAF_TYPE_LABELS[this.type]
    },
    additionalColumnCount() {
      return this.columns[this.type].length
    },
    _adoptOrder() {
      return ADOPT_ORDER_LABELS[this.adoptOrder]
    },
    _orderAdjustment() {
      const _1 = this.orderAdjustment.optionsInSelection.selected
      const _2 = this.orderAdjustment.unnecessarySelection.selected
      const p = this.orderAdjustment.priority

      if (!_1 && !_2) {
        return 'なし'
      }
      if (_1 && !_2) {
        return '1'
      }
      if (!_1 && _2) {
        return '2'
      }

      if (p === 'optionsInSelection') {
        return '1 → 2'
      }
      return '2 → 1'
    },
  },
}
</script>
